import React, { Component } from 'react';
import keycode from 'keycode';
import { KeyboardShortcutEnhancer } from '@econ/ui-elements';
import { tByRoute } from '../../../shared/components/l10n/l10n';
import { analytics } from '@economic/react-app';

const getNextActiveResultIndex = (index, direction, results) => {
    const nextIndex = index + direction;

    if (!results[nextIndex]) {
        return -1;
    }

    return nextIndex;
};

interface Props {
    cache: any;
    close: Function;
    navigate: any;
    results: any[];
}

interface State {
    activeResultIndex: number;
}
export default class QuicksearchResults extends Component<Props, State> {
    state = { activeResultIndex: 0 };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ activeResultIndex: 0 });
    }

    render() {
        return (
            <KeyboardShortcutEnhancer onKeyDown={this.onKeyDown}>
                <ul>{this.renderResults(this.props.results)}</ul>
            </KeyboardShortcutEnhancer>
        );
    }

    renderResults = results => {
        const { activeResultIndex } = this.state;
        const groups = {};

        results.forEach((result, i) => {
            if (result.section) {
                if (!groups[result.section]) {
                    groups[result.section] = {};
                }

                const group = result.group || '';

                if (!groups[result.section][group]) {
                    groups[result.section][group] = [];
                }

                groups[result.section][group].push({
                    title: result.title,
                    action: result.action,
                    index: i,
                    key: `${result.section}.${result.group}.${result.title}`,
                });
            }
        });

        return Object.keys(groups).map(tab => {
            const tabCache = this.props.cache.find(tabLink => tabLink.title === tab && tabLink.type === 'tab') || {};

            return (
                <li key={tab} className="quicksearch__results__group">
                    <a href={tabCache.title} onClick={tabCache.action ? this.gotoResult(tabCache.action, tab) : undefined}>
                        {tByRoute(tab) ?? tab}
                    </a>
                    <ul>
                        {Object.keys(groups[tab]).map(menu => (
                            <li key={menu} className="quicksearch__results__section">
                                <span className={groups[tab][menu][0].index === activeResultIndex ? 'active' : undefined}>
                                    {tByRoute(menu) ?? menu}
                                </span>
                                <ul>
                                    {groups[tab][menu].map(link => (
                                        <li
                                            className={link.index === activeResultIndex ? 'active' : undefined}
                                            key={link.key}
                                            onMouseOver={() => this.setState({ activeResultIndex: link.index })}>
                                            <a href={link.title} onClick={this.gotoResult(link.action, link.title)}>
                                                {tByRoute(link.title) ?? link.title}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        ))}
                    </ul>
                </li>
            );
        });
    };

    gotoResult = (action, label) => event => {
        event.preventDefault();
        action(this.props.navigate);
        analytics.gtm('search', { gaCategory: 'search', gaAction: 'search', gaLabel: label });
        this.props.close();
    };

    onKeyDown = event => {
        const { activeResultIndex } = this.state;
        const { results } = this.props;

        if (event.keyCode === keycode('enter')) {
            this.gotoResult(results[activeResultIndex].action, results[activeResultIndex].title)(event);
            return;
        }

        if (event.keyCode === keycode('up') || event.keyCode === keycode('down')) {
            event.preventDefault();
            let nextActiveResultIndex;

            if (event.keyCode === keycode('up')) {
                nextActiveResultIndex = getNextActiveResultIndex(activeResultIndex, -1, results);
            } else if (event.keyCode === keycode('down')) {
                nextActiveResultIndex = getNextActiveResultIndex(activeResultIndex, 1, results);
            }

            if (nextActiveResultIndex === results.length || nextActiveResultIndex === -1) {
                return;
            }

            this.setState({ activeResultIndex: nextActiveResultIndex });
        }
    };
}
